import { useEffect, useState, lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// =====================
// Shared Components (NO LAZY - always needed)
// =====================
import Header from "./Component/Shared/Header";
import Footer from "./Component/Shared/Footer";
import Menu from "./Component/Shared/Menu";
import EnquiryForm from "./Component/Shared/EnquiryForm";

// =====================
// Lazy Loaded Pages
// =====================

// Pages
const Home = lazy(() => import("./Component/Pages/Home"));
const AboutUs = lazy(() => import("./Component/Pages/AboutUs"));
const Clients = lazy(() => import("./Component/Pages/Clients"));
const Careers = lazy(() => import("./Component/Pages/Careers"));
const ContactUs = lazy(() => import("./Component/Pages/ContactUs"));
const Services = lazy(() => import("./Component/Pages/services/Services"));
const SearchByLocation = lazy(() => import("./Component/Pages/Search-By-Location"));
const Corporate_video_production_company_in_mumbai = lazy(() =>
  import("./Component/Pages/Corporate-video-production-company-in-mumbai")
);

// Services
const WebService = lazy(() => import("./Component/Pages/services/WebService"));
const FilmsService = lazy(() => import("./Component/Pages/services/FilmsService"));
const DigitalMarketingServices = lazy(() =>
  import("./Component/Pages/services/DigitalMarketingServices")
);
const CreativeServices = lazy(() => import("./Component/Pages/services/CreativeServices"));
const DigitalActivationServices = lazy(() =>
  import("./Component/Pages/services/DigitalActivationServices")
);
const Photography = lazy(() => import("./Component/Pages/services/Photography"));

// Static pages
const Sitemap = lazy(() => import("./Component/Pages/Sitemap"));
const PrivacyPolicy = lazy(() => import("./Component/Pages/PrivacyPolicy"));
const Faq = lazy(() => import("./Component/Pages/Faq"));
const TermsOfUse = lazy(() => import("./Component/Pages/TermsOfUse"));

// =====================
// Work Pages (lazy)
// =====================
const ElleysElectrics = lazy(() => import("./Component/Pages/work/Website/ElleysElectrics"));
const Memoria = lazy(() => import("./Component/Pages/work/Memoria"));
const WelspunGroup = lazy(() => import("./Component/Pages/work/video_production/WelspunGroup"));
const WelspunCSR = lazy(() => import("./Component/Pages/work/video_production/WelspunCSR"));
const ICICIPrudential = lazy(() => import("./Component/Pages/work/ICICIPrudential"));
const McDowellNo1 = lazy(() => import("./Component/Pages/work/digital_activation/McDowellNo1"));
const OurWork = lazy(() => import("./Component/Pages/OurWork"));
const WelspunBKG = lazy(() => import("./Component/Pages/work/video_production/WelpsunBKG"));
const Notandas = lazy(() => import("./Component/Pages/work/Website/Notandas"));
const Vardhman = lazy(() => import("./Component/Pages/work/Website/Vardhman"));
const Dabur = lazy(() => import("./Component/Pages/work/digital_marketing/Dabur"));
const IndusInd = lazy(() => import("./Component/Pages/work/digital_marketing/IndusInd"));
const AdvanceSolution = lazy(() => import("./Component/Pages/work/digital_marketing/AdvanceSolution"));
const IciciPensionFund = lazy(() => import("./Component/Pages/work/digital_marketing/IciciPensionFund"));
const IciciPrudentialDM = lazy(() => import("./Component/Pages/work/digital_marketing/IciciPrudential"));
const JindalSAW = lazy(() => import("./Component/Pages/work/digital_marketing/JindalSAW"));
const OneGamingArcade = lazy(() => import("./Component/Pages/work/digital_marketing/OneGamingArcade"));
const PatelUrologyHospital = lazy(() => import("./Component/Pages/work/digital_marketing/PatelUrologyHospital"));
const Mpuh2 = lazy(() => import("./Component/Pages/work/digital_marketing/Mpuh2"));
const ICICI_Creatives = lazy(() => import("./Component/Pages/work/digital_marketing/ICICI_Creatives"));
const SkyGreens = lazy(() => import("./Component/Pages/work/digital_marketing/SkyGreens"));
const SpeedOfSound = lazy(() => import("./Component/Pages/work/digital_marketing/SpeedOfSound"));
const Tiger = lazy(() => import("./Component/Pages/work/digital_marketing/Tiger"));
const Sunpharma = lazy(() => import("./Component/Pages/work/digital_marketing/Sunpharma"));

// Video Production
const AlkemLaboratories = lazy(() => import("./Component/Pages/work/video_production/AlkemLaboratories"));
const CanadianWoods = lazy(() => import("./Component/Pages/work/video_production/CanadianWoods"));
const DHCInternational = lazy(() => import("./Component/Pages/work/video_production/DHCInternational"));
const DodhiaCorporateFilm = lazy(() => import("./Component/Pages/work/video_production/DodhiaCorporateFilm"));
const DodhiaTextiles = lazy(() => import("./Component/Pages/work/video_production/DodhiaTextiles"));
const DoradoIvory = lazy(() => import("./Component/Pages/work/video_production/DoradoIvory"));
const ISolus = lazy(() => import("./Component/Pages/work/video_production/ISolus"));
const JesonsTechCentre = lazy(() => import("./Component/Pages/work/video_production/JesonsTechCentre"));
const KukuFm = lazy(() => import("./Component/Pages/work/video_production/KukuFm"));
const NeoNiche = lazy(() => import("./Component/Pages/work/video_production/NeoNiche"));
const QR678 = lazy(() => import("./Component/Pages/work/video_production/QR678"));
const Recipe = lazy(() => import("./Component/Pages/work/video_production/Recipe"));
const RockmanIndustries = lazy(() => import("./Component/Pages/work/video_production/RockmanIndustries"));
const SpeakEvent = lazy(() => import("./Component/Pages/work/video_production/SpeakEvent"));
const SpeakHealth = lazy(() => import("./Component/Pages/work/video_production/SpeakHealth"));
const VijaySales = lazy(() => import("./Component/Pages/work/video_production/VijaySales"));

// Creative Design
const RsblCalendar = lazy(() => import("./Component/Pages/work/creative_design/RsblCalendar"));
const RsblCalendar2025 = lazy(() => import("./Component/Pages/work/creative_design/RsblCalendar2025"));
const AymSyntexAnnualReport = lazy(() =>
  import("./Component/Pages/work/creative_design/AymSyntexAnnualReport")
);
const CreativeMemoria = lazy(() => import("./Component/Pages/work/creative_design/Memoria"));

// Other works
const DodhiaWeb = lazy(() => import("./Component/Pages/work/Website/DodhiaWebsite"));
const BhsWeb = lazy(() => import("./Component/Pages/work/Website/BhsWeb"));
const Digisuraksha = lazy(() => import("./Component/Pages/work/Website/Digisuraksha"));
const Solstice = lazy(() => import("./Component/Pages/work/Website/Solstice"));
const Jcb = lazy(() => import("./Component/Pages/work/Website/jcb"));
const KhalidaToukkani = lazy(() => import("./Component/Pages/work/Website/KhalidaToukkani"));

// =====================
// App Component
// =====================

function App() {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const [isCursorOver, setIsCursorOver] = useState(false);
  const [isCursorOverBlack, setIsCursorOverBlack] = useState(false);
  const [isCursorOverRed, setIsCursorOverRed] = useState(false);
  const [isCursorOverFooter, setIsCursorOverFooter] = useState(false);
  const [isCursorOverRedSmall, setIsCursorOverRedSmall] = useState(false);

  useEffect(() => {
    const updatePosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    document.addEventListener("mousemove", updatePosition);
    return () => document.removeEventListener("mousemove", updatePosition);
  }, []);
  
  // ===== FIXED HANDLERS (IMPORTANT) =====
  const handleMouseEnter = () => setIsCursorOver(true);
  const handleMouseLeave = () => setIsCursorOver(false);

  const handleMouseEnterBlack = () => setIsCursorOverBlack(true);
  const handleMouseLeaveBlack = () => setIsCursorOverBlack(false);

  const handleMouseEnterRed = () => setIsCursorOverRed(true);
  const handleMouseLeaveRed = () => setIsCursorOverRed(false);

  const handleMouseEnterFooter = () => setIsCursorOverFooter(true);
  const handleMouseLeaveFooter = () => setIsCursorOverFooter(false);

  const handleMouseEnterRedSmall = () => setIsCursorOverRedSmall(true);
  const handleMouseLeaveRedSmall = () => setIsCursorOverRedSmall(false);

  return (
    <main>
      <div
        className={`custom-cursor ${
          isCursorOver
            ? "active"
            : isCursorOverFooter
            ? "active white"
            : isCursorOverRed
            ? "white-Cursor"
            : isCursorOverRedSmall
            ? "active_small"
            : "normal_cursor"
        }`}
        style={{ left: position.x, top: position.y }}
      />

      <HelmetProvider>
        <BrowserRouter>
          <Header />
          <EnquiryForm />
          <Menu
            mouseEnterOnRed={handleMouseEnterRed}
            mouseLeaveOnRed={handleMouseLeaveRed}
            mouseEnterOnBlack={handleMouseEnterBlack}
            mouseLeaveOnBlack={handleMouseLeaveBlack}
            mouseEnterOnFooter={handleMouseEnterFooter}
            mouseLeaveOnFooter={handleMouseLeaveFooter}
          />

          {/* 🔥 LAZY LOADING WRAPPER */}
          <Suspense fallback={<div style={{ padding: "100px" }}>Loading...</div>}>
            <Routes>

              <Route path="*" element={<Home />} />

              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact-us" element={<ContactUs />} />

              <Route path="/search-by-location" element={<SearchByLocation />} />
              <Route
                path="/corporate-video-production-company-in-mumbai"
                element={<Corporate_video_production_company_in_mumbai />}
              />

              <Route path="/faq" element={<Faq />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />

              <Route path="/website-and-mobile/" element={<WebService />} />
              <Route path="/video-production/" element={<FilmsService />} />
              <Route path="/digital-marketing/" element={<DigitalMarketingServices />} />
              <Route path="/Creative-Services" element={<CreativeServices />} />
              <Route path="/Digital-Activation-Services" element={<DigitalActivationServices />} />
              <Route path="/still-photography/" element={<Photography />} />

              <Route path="/works" element={<OurWork />} />

              <Route path="/alkemlaboratories" element={<AlkemLaboratories />} />
              <Route path="/canadian-woods" element={<CanadianWoods />} />
              <Route path="/dodhia-corporate-film" element={<DodhiaCorporateFilm />} />
              <Route path="/dodhia-textiles" element={<DodhiaTextiles />} />
              <Route path="/dorado-ivory" element={<DoradoIvory />} />
              <Route path="/isolus" element={<ISolus />} />
              <Route path="/kukufm" element={<KukuFm />} />
              <Route path="/neo-niche" element={<NeoNiche />} />
              <Route path="/qr678" element={<QR678 />} />
              <Route path="/recipe" element={<Recipe />} />
              <Route path="/rockman-industries" element={<RockmanIndustries />} />
              <Route path="/speak-event" element={<SpeakEvent />} />
              <Route path="/speak-health" element={<SpeakHealth />} />
              <Route path="/vijay-sales" element={<VijaySales />} />

              <Route path="/rsbl-calendar" element={<RsblCalendar />} />
              <Route path="/rsbl-calendar_2025" element={<RsblCalendar2025 />} />
              <Route path="/aym-syntex-annual-report" element={<AymSyntexAnnualReport />} />
              <Route path="/creative-memoria" element={<CreativeMemoria />} />

              <Route path="/dodhiaweb" element={<DodhiaWeb />} />
              <Route path="/bhsweb" element={<BhsWeb />} />
              <Route path="/digisuraksha" element={<Digisuraksha />} />
              <Route path="/solstice" element={<Solstice />} />
              <Route path="/jcb" element={<Jcb />} />
              <Route path="/KhalidaToukkani" element={<KhalidaToukkani />} />

              <Route path="/clients" element={<Clients />} />
              <Route path="/careers" element={<Careers />} />

              <Route path="/contact-us" element={<ContactUs />} />

            </Routes>
          </Suspense>

          <Footer
            mouseEnterOnRed={handleMouseEnterRed}
            mouseLeaveOnRed={handleMouseLeaveRed}
            mouseEnterOnBlack={handleMouseEnterBlack}
            mouseLeaveOnBlack={handleMouseLeaveBlack}
            mouseEnterOnFooter={handleMouseEnterFooter}
            mouseLeaveOnFooter={handleMouseLeaveFooter}
          />
        </BrowserRouter>
      </HelmetProvider>
    </main>
  );
}

export default App;